import type { PropsWithChildren } from 'react';
import type { LabelColor } from 'src/legacy/components/label';

import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

type Tab = {
  color?: LabelColor;
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    color: 'info',
    label: 'all',
    value: 'all',
  },
  {
    color: 'success',
    label: 'ready',
    value: 'ready',
  },
  {
    color: 'warning',
    label: 'pending',
    value: 'pending',
  },
  {
    color: 'secondary',
    label: 'full',
    value: 'full',
  },
  {
    color: 'error',
    label: 'inactivated',
    value: 'inactivated',
  },
];

type FosterFamilyListNavigatorContextType = {
  currentTab: string;
  tabs: Tab[];
};

const defaultFosterFamilyListNavigatorContextValue = {
  currentTab: 'all',
  tabs: defaultTabs,
};

export const FosterFamilyListNavigatorContext =
  createContext<FosterFamilyListNavigatorContextType>(
    defaultFosterFamilyListNavigatorContextValue
  );

type FosterFamilyListNavigatorContextProviderProps = PropsWithChildren<any>;

export const FosterFamilyListNavigatorContextProvider = ({
  children,
}: FosterFamilyListNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<FosterFamilyListNavigatorContextType>(
      defaultFosterFamilyListNavigatorContextValue
    );

  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname) {
      let currentTab = pathname
        .replace(`${PATH_DASHBOARD.fosterFamily.list}`, '')
        .replace('/', '');
      currentTab = currentTab || defaultTabs[0].value;
      setContextValue((prev) => ({ ...prev, currentTab }));
    } else {
      navigate(PATH_DASHBOARD.fosterFamily.list);
    }
  }, [navigate, pathname]);

  return (
    <FosterFamilyListNavigatorContext.Provider value={{ ...contextValue }}>
      {children}
    </FosterFamilyListNavigatorContext.Provider>
  );
};

export const useFosterFamilyListNavigatorContext = () => {
  return useContext(FosterFamilyListNavigatorContext);
};
